import React, { useEffect } from 'react'
import Header from '../../components/index/header'
import LogoRemoto from '../../img/app-1.png'
import LogoGeo from '../../img/geo-2.png'
import LogoGestion from '../../img/check-3.png'
import ArquitectEs from '../../img/mdm-arq-es.png'
import ArquitectEn from '../../img/mdm-arq-en.png'
import Logo from '../../img/img-device-conection-01.svg'
import Card from '../../components/index/card'
import Footer from '../../components/index/footer'
import styles from '../../css/Index.module.css'
import CardFunction from '../../components/index/cardFunctions'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'

export default function Index () {
  const { t, i18n } = useTranslation('index')
  const location = useLocation()

  const mainCards = [
    {
      title: t('mainCards.remoto.titleCard'),
      body: t('mainCards.remoto.bodyCard'),
      logo: LogoRemoto
    },
    {
      title: t('mainCards.geolocalizacion.titleCard'),
      body: t('mainCards.geolocalizacion.bodyCard'),
      logo: LogoGeo
    },
    {
      title: t('mainCards.gestion.titleCard'),
      body: t('mainCards.gestion.bodyCard'),
      logo: LogoGestion
    }
  ]

  const functionalCards = [
    {
      text: t('functionalCards.one'),
      logo: LogoGeo
    },
    {
      text: t('functionalCards.two'),
      logo: LogoGeo
    },
    {
      text: t('functionalCards.three'),
      logo: LogoGeo
    },
    {
      text: t('functionalCards.four'),
      logo: LogoGeo
    },
    {
      text: t('functionalCards.five'),
      logo: LogoGeo
    },
    {
      text: t('functionalCards.six'),
      logo: LogoGeo
    }
  ]

  useEffect(() => {
    if (location?.state?.data !== undefined) {
      if (location?.state?.data?.redirect) {
        if (location?.state?.status === 403) {
          Swal.fire({
            icon: 'error',
            title: i18n?.language === 'en' ? 'Session has Expired' : i18n?.language === 'es' ? 'La Sesión ha Caducado' : null,
            text: i18n?.language === 'en' ? 'Please log in again!' : i18n?.language === 'es' ? '¡Inicie sesión nuevamente!' : null,
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: i18n?.language === 'en' ? 'Oops...' : i18n?.language === 'es' ? 'Oops...' : null,
            text: i18n?.language === 'en' ? 'Something went wrong!' : i18n?.language === 'es' ? 'Algo salió mal!' : null,
            showConfirmButton: false,
            timer: 1500
          })
        }
      }
      sessionStorage.clear()
    }
  }, [location?.state])

  return (
    <>
      <Header />

      <main className={styles.bodyIndex}>
        <div className="container">
          <div className={styles.contentTitles}>
            <h1 className={styles.title}>
              {t('mainTitle1')} <br />
              {t('mainTitle2')}
            </h1>
            <h3 className={styles.subtitle}>
              {t('secondaryTitle1')} <br />
              {t('secondaryTitle2')}
            </h3>
          </div>
          <div className={styles.spaceCards}>
            {mainCards.map((card, index) => (
              <Card logo={card.logo} title={card.title} text={card.body} key={index}/>
            ))}
          </div>
        </div>
      </main>

      <section className="container">
        <div className={styles.cardsFunctions}>
          {functionalCards.map((card, index) => (
            <CardFunction icon={card.logo} text={card.text} key={index}/>
          ))}
        </div>
      </section>

      <section className={styles.sectionArquitect}>
        <div className={styles.encabezados}>
          <h2>
            {t('mainSubtitle1')} <br />
            {t('mainSubtitle2')}
          </h2>
          <p>
            {t('mainParagraph1')}
            <br />
            <br />
            {t('mainParagraph2')}
            <br />
          </p>
        </div>
        <div className={styles.imgArquitect}>
          <img src={i18n.language === 'es' ? ArquitectEs : i18n.language === 'en' ? ArquitectEn : undefined} alt="arquitectura" />
        </div>
      </section>

      <section className={styles.sectionFunctions}>
        <div className={styles.functions}>
          <h2>
            {t('secondarySubtitle1')} <br />
            {t('secondarySubtitle2')}
          </h2>
          <ul>
            <li>
              <i className="fa-solid fa-circle-check"></i>
              {t('functions.one')}
            </li>
            <li>
              <i className="fa-solid fa-circle-check"></i>
              {t('functions.two')}
            </li>
            <li>
              <i className="fa-solid fa-circle-check"></i>
              {t('functions.three')}
            </li>
            <li>
              <i className="fa-solid fa-circle-check"></i>
              {t('functions.four')}
            </li>
          </ul>
        </div>
        <div className={styles.imgFunctions}>
          <img src={Logo} alt="funciones" />
        </div>
      </section>

      <Footer />
    </>
  )
}
